/**
 * Macmerise Account Dropdown
 * Inline phone → OTP login in the header dropdown.
 * Reads mc_session_info cookie for logged-in state.
 * Uses checkout API for OTP send/verify.
 */
(function () {
  'use strict';

  var API_BASE = 'https://checkout-api.macmerise.com';
  var COUNTRY_CODE = '+91';
  var RESEND_COOLDOWN_SECS = 30;
  var WHATSAPP_COOLDOWN_SECS = 45;

  /* ════════════════════════════════════════════════════════════
     Cookie Helper
     ════════════════════════════════════════════════════════════ */

  function getSessionInfo() {
    try {
      var match = document.cookie.match(/(?:^|;\s*)mc_session_info=([^;]*)/);
      if (!match || !match[1]) return null;
      var parsed = JSON.parse(decodeURIComponent(match[1]));
      if (typeof parsed !== 'object' || parsed === null) return null;
      return parsed;
    } catch (_) {
      return null;
    }
  }

  /* ════════════════════════════════════════════════════════════
     State
     ════════════════════════════════════════════════════════════ */

  var state = {
    sessionId: null,
    phone: '',
    resendTimerId: null,
    whatsappTimerId: null,
    sendingOtp: false,
    verifyingOtp: false
  };

  /* ════════════════════════════════════════════════════════════
     DOM
     ════════════════════════════════════════════════════════════ */

  var dom = {};

  function cacheDom() {
    dom.dropdown = document.getElementById('mc-account-dropdown');
    dom.loggedIn = document.getElementById('mc-acct-logged-in');
    dom.greeting = document.getElementById('mc-acct-greeting');
    dom.signout = document.getElementById('mc-acct-signout');

    dom.stepPhone = document.getElementById('mc-acct-step-phone');
    dom.phoneInput = document.getElementById('mc-acct-phone');
    dom.phoneBtn = document.getElementById('mc-acct-phone-btn');
    dom.phoneError = document.getElementById('mc-acct-phone-error');

    dom.stepOtp = document.getElementById('mc-acct-step-otp');
    dom.otpPhone = document.getElementById('mc-acct-otp-phone');
    dom.otpInputs = document.getElementById('mc-acct-otp-inputs');
    dom.otpDigits = dom.otpInputs.querySelectorAll('.mc-acct-otp-digit');
    dom.otpBtn = document.getElementById('mc-acct-otp-btn');
    dom.otpError = document.getElementById('mc-acct-otp-error');
    dom.editPhone = document.getElementById('mc-acct-edit-phone');
    dom.resendBtn = document.getElementById('mc-acct-resend');
    dom.whatsappBtn = document.getElementById('mc-acct-whatsapp');

    dom.stepRegister = document.getElementById('mc-acct-step-register');
    dom.nameInput = document.getElementById('mc-acct-name');
    dom.emailInput = document.getElementById('mc-acct-email');
    dom.registerBtn = document.getElementById('mc-acct-register-btn');
    dom.registerError = document.getElementById('mc-acct-register-error');
  }

  /* ════════════════════════════════════════════════════════════
     API
     ════════════════════════════════════════════════════════════ */

  function apiCall(endpoint, body) {
    return fetch(API_BASE + endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().catch(function () {
        throw new Error('Something went wrong. Please try again.');
      }).then(function (data) {
        if (!res.ok) throw new Error(data.error || 'Request failed');
        return data;
      });
    });
  }

  /* ════════════════════════════════════════════════════════════
     Error Display
     ════════════════════════════════════════════════════════════ */

  function showError(el, msg) {
    el.textContent = msg;
    el.hidden = false;
  }

  function hideError(el) {
    el.textContent = '';
    el.hidden = true;
  }

  /* ════════════════════════════════════════════════════════════
     Button Loading
     ════════════════════════════════════════════════════════════ */

  function setLoading(btn, loading, text) {
    if (loading) {
      btn.dataset.orig = btn.textContent;
      btn.textContent = text || 'Please wait...';
      btn.disabled = true;
    } else {
      btn.textContent = btn.dataset.orig || btn.textContent;
      btn.disabled = false;
    }
  }

  /* ════════════════════════════════════════════════════════════
     Dropdown Keep-Open (prevent hover-close during form input)
     ════════════════════════════════════════════════════════════ */

  var userEngaged = false;

  function initKeepOpen() {
    // Track deliberate user interaction (click/tap into an input) vs auto-focus
    dom.dropdown.addEventListener('pointerdown', function (e) {
      if (e.target.tagName === 'INPUT') {
        userEngaged = true;
      }
    });

    // Reset engagement when dropdown closes naturally (user walked away)
    dom.dropdown.addEventListener('toggle', function () {
      if (!dom.dropdown.open) {
        userEngaged = false;
      }
    });

    // Re-open if theme tries to close while user is mid-login
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'open' && !dom.dropdown.open && userEngaged) {
          dom.dropdown.open = true;
        }
      });
    });
    observer.observe(dom.dropdown, { attributes: true });
  }

  /* ════════════════════════════════════════════════════════════
     View Switching
     ════════════════════════════════════════════════════════════ */

  function hideAllSteps() {
    dom.stepPhone.hidden = true;
    dom.stepOtp.hidden = true;
    dom.stepRegister.hidden = true;
    dom.loggedIn.hidden = true;
  }

  function showLoggedIn(info) {
    hideAllSteps();
    dom.loggedIn.hidden = false;

    var fullName = (info && info.name) ? info.name : '';
    var firstName = fullName.split(/\s+/)[0] || '';
    var phone = (info && info.phone) ? info.phone : '';
    var greeting = firstName ? 'Hi, ' + firstName : (phone ? 'Hi, ' + phone : 'Welcome back');
    dom.greeting.textContent = greeting;

    // Notify checkout popup that session is now active
    notifyCheckoutPopup();
  }

  function showPhoneStep() {
    hideAllSteps();
    dom.stepPhone.hidden = false;
    hideError(dom.phoneError);
    dom.phoneInput.value = '';
    dom.phoneBtn.disabled = false;
    clearCooldown('sms');
    clearCooldown('whatsapp');
    state.sendingOtp = false;
    state.verifyingOtp = false;
  }

  function showOtpStep() {
    hideAllSteps();
    dom.stepOtp.hidden = false;
    hideError(dom.otpError);
    clearOtpInputs();
    dom.otpDigits[0].focus();
  }

  function showRegisterStep() {
    hideAllSteps();
    dom.stepRegister.hidden = false;
    hideError(dom.registerError);
    dom.nameInput.value = '';
    dom.emailInput.value = '';
    dom.nameInput.focus();
  }

  /* ════════════════════════════════════════════════════════════
     Phone Step
     ════════════════════════════════════════════════════════════ */

  function validatePhone(digits) {
    return /^[6-9]\d{9}$/.test(digits);
  }

  function sendOtp(digits) {
    if (state.sendingOtp) return;
    state.sendingOtp = true;

    hideError(dom.phoneError);
    setLoading(dom.phoneBtn, true, 'Sending...');

    state.phone = COUNTRY_CODE + digits;
    dom.otpPhone.textContent = COUNTRY_CODE + ' ' + digits;

    apiCall('/api/otp/send', {
      countryCode: COUNTRY_CODE,
      phone: digits,
      shopDomain: window.Shopify && window.Shopify.shop ? window.Shopify.shop : 'macmerise-2.myshopify.com'
    })
      .then(function (data) {
        setLoading(dom.phoneBtn, false);
        state.sessionId = data.sessionId;
        showOtpStep();
        setReady('sms');
        setReady('whatsapp');
        afterSend(data);
      })
      .catch(function (err) {
        setLoading(dom.phoneBtn, false);
        showError(dom.phoneError, err.message || 'Failed to send OTP.');
      })
      .finally(function () { state.sendingOtp = false; });
  }

  function handlePhoneSubmit() {
    var digits = dom.phoneInput.value.trim().replace(/\D/g, '');
    if (digits.length > 0 && digits[0] === '0') {
      showError(dom.phoneError, 'Mobile numbers don\u2019t start with 0. Try without it.');
      return;
    }
    if (!validatePhone(digits)) {
      showError(dom.phoneError, 'Enter a valid 10-digit mobile number.');
      return;
    }
    sendOtp(digits);
  }

  function handlePhoneInput() {
    var raw = dom.phoneInput.value.trim().replace(/\D/g, '');

    // Block leading zero
    if (raw.length > 0 && raw[0] === '0') {
      showError(dom.phoneError, 'Mobile numbers don\u2019t start with 0. Try without it.');
      return;
    }

    hideError(dom.phoneError);

    // Auto-advance on 10 valid digits
    if (raw.length === 10 && validatePhone(raw)) {
      sendOtp(raw);
    }
  }

  /* ════════════════════════════════════════════════════════════
     OTP Step
     ════════════════════════════════════════════════════════════ */

  function clearOtpInputs() {
    dom.otpDigits.forEach(function (d) {
      d.value = '';
      d.classList.remove('mc-acct-otp-digit--filled');
    });
  }

  function getOtpValue() {
    var code = '';
    dom.otpDigits.forEach(function (d) { code += d.value; });
    return code;
  }

  function initOtpInputs() {
    dom.otpDigits.forEach(function (input, i) {
      input.addEventListener('input', function (e) {
        var val = e.target.value.replace(/\D/g, '');
        e.target.value = val.slice(0, 1);
        if (val) {
          input.classList.add('mc-acct-otp-digit--filled');
        } else {
          input.classList.remove('mc-acct-otp-digit--filled');
        }
        if (val && i < dom.otpDigits.length - 1) {
          dom.otpDigits[i + 1].focus();
        }
        // Auto-submit when all 6 filled
        if (getOtpValue().length === 6) {
          handleOtpSubmit();
        }
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Backspace' && !e.target.value && i > 0) {
          dom.otpDigits[i - 1].focus();
        }
      });

      input.addEventListener('focus', function () {
        try { input.select(); } catch (_) { /* ignore */ }
      });

      // Paste support
      input.addEventListener('paste', function (e) {
        e.preventDefault();
        var text = (e.clipboardData || window.clipboardData).getData('text').replace(/\D/g, '').slice(0, 6 - i);
        text.split('').forEach(function (char, j) {
          if (dom.otpDigits[i + j]) {
            dom.otpDigits[i + j].value = char;
            if (char) dom.otpDigits[i + j].classList.add('mc-acct-otp-digit--filled');
          }
        });
        if (text.length > 0) {
          dom.otpDigits[Math.min(i + text.length, dom.otpDigits.length) - 1].focus();
        }
        // Auto-submit after paste
        if (getOtpValue().length === 6) {
          handleOtpSubmit();
        }
      });
    });
  }

  function handleOtpSubmit() {
    if (state.verifyingOtp) return;

    var code = getOtpValue();
    hideError(dom.otpError);

    if (code.length !== 6) {
      showError(dom.otpError, 'Enter the complete 6-digit code.');
      return;
    }

    state.verifyingOtp = true;
    setLoading(dom.otpBtn, true, 'Verifying...');

    apiCall('/api/otp/verify', {
      sessionId: state.sessionId,
      otp: code,
      phone: state.phone
    })
      .then(function (data) {
        setLoading(dom.otpBtn, false);
        clearCooldown('sms');
        clearCooldown('whatsapp');

        if (data.isNewUser) {
          // New user — collect name & email before completing login
          showRegisterStep();
        } else {
          // Existing user — cookies already set with name
          var info = getSessionInfo();
          showLoggedIn(info);
        }
      })
      .catch(function (err) {
        setLoading(dom.otpBtn, false);
        showError(dom.otpError, err.message || 'Invalid OTP.');
      })
      .finally(function () { state.verifyingOtp = false; });
  }

  /* ════════════════════════════════════════════════════════════
     Resend Cooldowns — one per channel, so a WhatsApp send never
     locks or unlocks SMS and the other way round
     ════════════════════════════════════════════════════════════ */

  var COOLDOWNS = {
    sms: { secs: RESEND_COOLDOWN_SECS, timer: 'resendTimerId', button: 'resendBtn', waiting: 'Retry SMS in ', ready: 'Resend SMS' },
    whatsapp: { secs: WHATSAPP_COOLDOWN_SECS, timer: 'whatsappTimerId', button: 'whatsappBtn', waiting: 'Retry WhatsApp in ', ready: 'Send on WhatsApp' }
  };

  function startCooldown(channel) {
    var c = COOLDOWNS[channel];
    var btn = dom[c.button];
    var seconds = c.secs;
    clearCooldown(channel);
    btn.disabled = true;

    function tick() {
      if (seconds <= 0) {
        setReady(channel);
        return;
      }
      btn.textContent = c.waiting + seconds + 's';
      seconds--;
    }

    tick();
    state[c.timer] = setInterval(tick, 1000);
  }

  function clearCooldown(channel) {
    var timer = COOLDOWNS[channel].timer;
    if (state[timer]) {
      clearInterval(state[timer]);
      state[timer] = null;
    }
  }

  function setReady(channel) {
    var c = COOLDOWNS[channel];
    clearCooldown(channel);
    dom[c.button].disabled = false;
    dom[c.button].textContent = c.ready;
  }

  // The server reports the channel it actually used (an SMS that fails falls
  // back to WhatsApp), so the line and the cooldown follow `method`, not the
  // button the customer pressed.
  function afterSend(data) {
    var channel = data && data.method === 'whatsapp' ? 'whatsapp' : 'sms';
    var label = dom.otpPhone.parentNode.previousSibling;
    if (label && label.nodeType === 3) {
      label.nodeValue = channel === 'whatsapp' ? 'Sent on WhatsApp to ' : 'Sent by SMS to ';
    }
    startCooldown(channel);
  }

  function handleResend() {
    clearOtpInputs();
    hideError(dom.otpError);

    var digits = state.phone.replace(/\D/g, '').slice(-10);
    setLoading(dom.otpBtn, true, 'Resending...');
    dom.resendBtn.disabled = true;

    apiCall('/api/otp/send', {
      countryCode: COUNTRY_CODE,
      phone: digits,
      shopDomain: window.Shopify && window.Shopify.shop ? window.Shopify.shop : 'macmerise-2.myshopify.com'
    })
      .then(function (data) {
        setLoading(dom.otpBtn, false);
        state.sessionId = data.sessionId;
        afterSend(data);
        dom.otpDigits[0].focus();
      })
      .catch(function (err) {
        setLoading(dom.otpBtn, false);
        setReady('sms');
        showError(dom.otpError, err.message || 'Failed to resend OTP.');
      });
  }

  /* ════════════════════════════════════════════════════════════
     WhatsApp Resend
     ════════════════════════════════════════════════════════════ */

  function handleWhatsApp() {
    clearOtpInputs();
    hideError(dom.otpError);
    dom.whatsappBtn.disabled = true;
    dom.whatsappBtn.textContent = 'Sending...';

    var digits = state.phone.replace(/\D/g, '').slice(-10);

    apiCall('/api/otp/send', {
      countryCode: COUNTRY_CODE,
      phone: digits,
      shopDomain: window.Shopify && window.Shopify.shop ? window.Shopify.shop : 'macmerise-2.myshopify.com',
      preferWhatsApp: true
    })
      .then(function (data) {
        state.sessionId = data.sessionId;
        afterSend(data);
        dom.otpDigits[0].focus();
      })
      .catch(function (err) {
        setReady('whatsapp');
        showError(dom.otpError, err.message || 'Failed to send via WhatsApp.');
      });
  }

  /* ════════════════════════════════════════════════════════════
     New User Registration
     ════════════════════════════════════════════════════════════ */

  function handleRegister() {
    var name = dom.nameInput.value.trim();
    var email = dom.emailInput.value.trim();
    hideError(dom.registerError);

    if (!name) {
      showError(dom.registerError, 'Please enter your name.');
      dom.nameInput.focus();
      return;
    }

    // Basic email format check (only if provided)
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showError(dom.registerError, 'Please enter a valid email.');
      dom.emailInput.focus();
      return;
    }

    setLoading(dom.registerBtn, true, 'Saving...');

    var parts = name.split(/\s+/);
    var firstName = parts[0];
    var lastName = parts.slice(1).join(' ');

    apiCall('/api/customer/register', {
      firstName: firstName,
      lastName: lastName,
      email: email
    })
      .then(function (data) {
        setLoading(dom.registerBtn, false);
        // API re-issued cookies with name — read and show
        var info = getSessionInfo();
        // If cookie hasn't updated yet, use API response
        if (!info || !info.name) {
          info = { logged_in: true, name: data.name, phone: '' };
        }
        showLoggedIn(info);
      })
      .catch(function (err) {
        setLoading(dom.registerBtn, false);
        showError(dom.registerError, err.message || 'Failed to save. Please try again.');
      });
  }

  /* ════════════════════════════════════════════════════════════
     Notify Checkout Popup (sync session state)
     ════════════════════════════════════════════════════════════ */

  function notifyCheckoutPopup() {
    // The checkout popup reads state.sessionToken at init time.
    // After account dropdown login, update it so the popup knows we're authenticated.
    if (window.__mcCheckoutState) {
      window.__mcCheckoutState.sessionToken = 'cookie';
      var info = getSessionInfo();
      window.__mcCheckoutState.phone = (info && info.phone) ? info.phone : '';
    }
  }

  /* ════════════════════════════════════════════════════════════
     Sign Out
     ════════════════════════════════════════════════════════════ */

  function handleSignout() {
    // Clear client-readable cookie immediately so UI stays consistent
    document.cookie = 'mc_session_info=; path=/; domain=.macmerise.com; max-age=0';
    // Clear legacy localStorage
    localStorage.removeItem('mc_session_token');
    localStorage.removeItem('mc_session_phone');
    // Clear checkout popup state
    if (window.__mcCheckoutState) {
      window.__mcCheckoutState.sessionToken = null;
      window.__mcCheckoutState.phone = '';
      window.__mcCheckoutState.addresses = [];
    }
    showPhoneStep();
    // Clear httpOnly cookie via API (best-effort)
    fetch(API_BASE + '/api/session/logout', { method: 'POST', credentials: 'include' }).catch(function () {});
    // Clear any applied discount code by removing Shopify's discount cookie
    document.cookie = 'discount_code=; path=/; max-age=0';
    // Also clear via Shopify's checkout update (best-effort)
    fetch('/checkout?discount=', { method: 'GET', redirect: 'manual' }).catch(function () {});
  }

  /* ════════════════════════════════════════════════════════════
     Init
     ════════════════════════════════════════════════════════════ */

  function init() {
    cacheDom();
    if (!dom.dropdown) return;

    // Check logged-in state
    var info = getSessionInfo();
    if (info && info.logged_in) {
      showLoggedIn(info);
    }

    // Prevent hover-close during form interaction
    initKeepOpen();

    // "Sent on WhatsApp to …" wraps in this narrow card: keep the number and
    // its edit pencil together so the break falls before the number.
    var sentTo = document.createElement('span');
    sentTo.className = 'mc-acct-sent-to';
    dom.otpPhone.parentNode.insertBefore(sentTo, dom.otpPhone);
    sentTo.appendChild(dom.otpPhone);
    sentTo.appendChild(dom.editPhone);

    // Phone step
    dom.phoneBtn.addEventListener('click', handlePhoneSubmit);
    dom.phoneInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        handlePhoneSubmit();
      }
    });
    // Auto-advance on 10 digits
    dom.phoneInput.addEventListener('input', handlePhoneInput);

    // OTP step
    initOtpInputs();
    dom.otpBtn.addEventListener('click', handleOtpSubmit);
    dom.editPhone.addEventListener('click', showPhoneStep);
    dom.resendBtn.addEventListener('click', handleResend);
    dom.whatsappBtn.addEventListener('click', handleWhatsApp);

    // Register step
    dom.registerBtn.addEventListener('click', handleRegister);
    dom.nameInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); dom.emailInput.focus(); }
    });
    dom.emailInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); handleRegister(); }
    });

    // Sign out
    dom.signout.addEventListener('click', handleSignout);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
